<template>
    <div>
        <div
            v-for="(variant, index) in resource.selected_variants"
            :key="index"
            class="d-flex align-items-center selected-variant mb-1"
        >
            <img
                v-if="variant.image_url"
                :src="variant.image_url"
                :alt="variant.name"
                class="block img-responsive rounded-circle mr-1"
            >
            <div class="justify-self">
                {{ variant.name }}
            </div>
            <div
                class="ml-auto cursor-pointer text-danger"
                @click="removeVariant(index)"
            >
                <i class="fa fa-fw fa-times" />
            </div>
        </div>
        <Multiselect
            v-if="resource.variants.length > 1"
            :options="resource.variants"
            label="name"
            track-by="id"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :show-labels="false"
            @select="addVariant"
        />
    </div>
</template>

<script>

import Multiselect from 'vue-multiselect';

export default {

    components: {
        Multiselect,
    },

    props: {
        resource: {
            type: Object,
            required: true,
        },
    },

    methods: {
        update() {
            this.$emit('change', this.resource.selected_variants);
        },
        addVariant(selected) {
            this.resource.selected_variants.push(selected);
            this.update();
        },
        removeVariant(index) {
            this.resource.selected_variants.splice(index, 1);
            this.update();
        },
    },

};
</script>

<style scoped>
.multiselect__tags {
    height: auto !important;
}

img {
    width: 1.5rem;
    height: 1.5rem;
}
.selected-variant:hover {
    background: #f5f5f5;
}
</style>
